import { reactify } from '@zeiss/zui-react';
export const ZuiIconAlertsEwiErrorRound = reactify('zui-icon-alerts-ewi-error-round');
